export default "__VITE_ASSET__Bk5xwCPv__"